import { render, staticRenderFns } from "./ContractFulfillment.view.vue?vue&type=template&id=fbda668c&"
import script from "./ContractFulfillment.view.vue?vue&type=script&lang=js&"
export * from "./ContractFulfillment.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbda668c')) {
      api.createRecord('fbda668c', component.options)
    } else {
      api.reload('fbda668c', component.options)
    }
    module.hot.accept("./ContractFulfillment.view.vue?vue&type=template&id=fbda668c&", function () {
      api.rerender('fbda668c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/contract/ContractFulfillment.view.vue"
export default component.exports